export enum UserRoles {
  professional = 'Professional',
  clinicOwner = 'ClinicOwner',
  admin = 'Admin',
  secretary = 'Secretary',
}
